const duration = .4;

gsap.registerPlugin(ScrollTrigger);

const wrapX = gsap.utils.wrap([0, -100, 100]);
const wrapY = gsap.utils.wrap([-25, 0, 0]);
//content one


gsap.from('.content--1-gp-1', {
    scrollTrigger: {
        trigger: '.content--1__container',
        start: '10% 85%',
        markers: false

    },
    opacity: 0,
    x: wrapX,
    y: wrapY,
    stagger: '.2s'
});
gsap.from('.content--1-st-4', {
    scrollTrigger: {
        trigger: '.content--1-st-4',
        start: 'top 80%',
    },
    opacity: 0,
    x: 25,
    duration: duration
});
gsap.from('.content--1-st-5', {
    scrollTrigger: {
        trigger: '.content--1-st-4',
        start: 'top 80%',
    },
    opacity: 0,
    x: -25,
    duration: duration
});
gsap.from('.content--1-st-6', {
    scrollTrigger: {
        trigger: '.content--1-st-6',
        start: 'top 80%',
    },
    opacity: 0,
    x: -25,
    duration: duration
});
gsap.from('.content--1-st-7', {
    scrollTrigger: {
        trigger: '.content--1-st-7',
        start: 'top 80%',
    },
    opacity: 0,
    x: 25,
    duration: duration
});
gsap.from('.content--1-st-8', {
    scrollTrigger: {
        trigger: '.content--1-st-8',
        start: 'top 80%',
    },
    opacity: 0,
    x: 25,
    duration: duration
});
gsap.from('.content--1-st-9', {
    scrollTrigger: {
        trigger: '.content--1-st-9',
        start: 'top 80%',
    },
    opacity: 0,
    x: -25,
    duration: duration
});

//content two
gsap.from('.content--2-st-1', {
    scrollTrigger: {
        trigger: '.content--2-st-1',
        start: 'top 80%',
    },
    opacity: 0,
    x: -25,
    duration: duration,
    
});
gsap.from('.content--2-st-2', {
    scrollTrigger: {
        trigger: '.content--2-st-2',
        start: 'top 80%',
    },
    opacity: 0,
    x: 25,
    duration: duration
});